import {Product} from '@mintdata-wsp/common/controllers/network/generated/responses/Product';
import {ProductOffering} from '@mintdata-wsp/common/controllers/network/generated/responses/ProductOffering';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {ProductType} from '@mintdata-wsp/common/state/StorefrontState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {action} from 'mobx';

export class StorefrontController
{
    public syncStorefrontState():void
    {
        controllers.net.billing.getProductOffering()
            .then(action((po:ProductOffering)=>
            {
                const storefront = rootState.data.storefront;

                storefront.productOffering = po;
                storefront.cloudAccessProducts = this._getCloudAccessProducts();
                storefront.addonProducts = this._getAddonProducts();

            }));
    }

    private _getProducts():Product[] | null
    {
        const {productOffering} = rootState.data.storefront;
        if( !productOffering )
            return null;

        return productOffering.products;
    }

    private _getCloudAccessProducts():Product[] | null
    {
        const products = this._getProducts();
        if( !products )
            return null;

        const cloudAccessProducts = products.filter((product:Product)=>
                               {
                                   if( product.type !== ProductType.Cloud_Access )
                                       return false;

                                   let grant:any = product.grant;
                                   if( !grant )
                                       return false;

                                   try
                                   {
                                       grant = JSON.parse(grant);

                                       if (!grant.maxUsers || !grant.maxApplications)
                                           return false;

                                       return true;
                                   }
                                   catch (e)
                                   {
                                       return false;
                                   }
                               });

        return cloudAccessProducts;
    }

    private _getAddonProducts():Product[] | null
    {
        const products = this._getProducts();
        if( !products )
            return null;

        const addOnProducts = products.filter((product:Product)=>
                                                    {
                                                        if( product.type !== ProductType.Addon )
                                                            return false;

                                                        let grant:any = product.grant;
                                                        if( !grant )
                                                            return false;

                                                        try
                                                        {
                                                            grant = JSON.parse(grant);
                                                            return true;
                                                        }
                                                        catch (e)
                                                        {
                                                            return false;
                                                        }
                                                    });

        return addOnProducts;
    }
}
